import { setCookie } from "@utils/cookie";

const setLanguageCookie = (languageCode: string) => {
    setCookie("HB_LANGUAGE", languageCode, 30);
};

export { setLanguageCookie };
